import { get } from "lodash";
import ApiClient from '../utilities/http';
import cookie from "../utilities/cookie";
import { Endpoints } from "../utilities/endpoints";
import { IUser } from "../models/IUser";
import * as actionTypes from "../actionsTypes";

export type UserSettingsPayload = Pick<IUser, 'name' | 'email'> & {
    phone_number?: string;
    configured_time_zone?: string;
    options?: IUser['options'];
};

export type UserSettingsResponse = {
    user: IUser;
    time_zones: Record<string, string>;
    asset_types: Array<{ id: number; name: string; parent_id?: number | null }>;
    push_messaging_enabled?: boolean;
    public_vapid?: string | null;
};

export const updateCurrentUser = (user: IUser) => {
    cookie.put('current_user', JSON.stringify(user), "Lax", true);

    return {
        type: actionTypes.UPDATE_CURRENT_USER,
        payload: { currentUser: user },
    };
};

export const fetchUserSettings = () => {
    return (dispatch: any) => {
        ApiClient.get(Endpoints.USER_SETTINGS as string).then((response) => {
            const user = get(response, 'data.user');
            if (user) {
                dispatch(updateCurrentUser(user));
            }
        });
    };
};

export const getUserSettings = async (): Promise<UserSettingsResponse> => {
    const response = await ApiClient.get(Endpoints.USER_SETTINGS as string);
    return response.data;
};

export const saveUserSettings = async (data: UserSettingsPayload): Promise<IUser> => {
    const response = await ApiClient.put(Endpoints.USER_SETTINGS as string, data);
    return get(response, 'data.user');
};
